import { useState } from "react";

const FOLDER_COLORS = ["#ef4444","#f97316","#eab308","#22c55e","#3b82f6","#8b5cf6","#ec4899"];

export default function FolderManager({ folders, onCreateFolder, onDeleteFolder, activeFolder, onSelectFolder }) {
  const [creating, setCreating] = useState(false);
  const [newName, setNewName] = useState("");
  const [newColor, setNewColor] = useState("#ef4444");

  const handleCreate = async () => {
    if (!newName.trim()) return;
    await onCreateFolder(newName.trim(), newColor);
    setNewName("");
    setCreating(false);
  };

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 flex-wrap">
        {/* All QRs */}
        <button
          onClick={() => onSelectFolder(null)}
          className={`px-4 py-2 rounded-xl text-[10px] font-black uppercase transition-all ${!activeFolder ? "bg-red-600 text-white" : "bg-white/5 text-gray-500 hover:bg-white/10"}`}
        >
          All QRs
        </button>

        {/* Folders */}
        {folders.map(f => (
          <div key={f.id} className="relative group">
            <button
              onClick={() => onSelectFolder(f.id)}
              className={`px-4 py-2 rounded-xl text-[10px] font-black uppercase transition-all flex items-center gap-2 ${activeFolder === f.id ? "text-white shadow-lg" : "bg-white/5 text-gray-500 hover:bg-white/10"}`}
              style={activeFolder === f.id ? { background: f.color } : {}}
            >
              <span style={{ color: activeFolder === f.id ? "white" : f.color }}>●</span>
              {f.name}
            </button>
            <button
              onClick={() => onDeleteFolder(f.id)}
              className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white rounded-full text-[8px] hidden group-hover:flex items-center justify-center"
            >
              ×
            </button>
          </div>
        ))}

        {/* Create folder */}
        {creating ? (
          <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-xl p-2">
            <div className="flex gap-1">
              {FOLDER_COLORS.map(c => (
                <button
                  key={c}
                  onClick={() => setNewColor(c)}
                  className="w-4 h-4 rounded-full transition-all"
                  style={{ background: c, outline: newColor === c ? `2px solid white` : "none", outlineOffset: "2px" }}
                />
              ))}
            </div>
            <input
              autoFocus
              value={newName}
              onChange={e => setNewName(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleCreate()}
              placeholder="Folder name"
              className="bg-transparent text-white text-[10px] outline-none w-24"
            />
            <button onClick={handleCreate} className="text-green-400 text-[10px] font-black">✓</button>
            <button onClick={() => setCreating(false)} className="text-gray-500 text-[10px]">✕</button>
          </div>
        ) : (
          <button
            onClick={() => setCreating(true)}
            className="px-4 py-2 rounded-xl text-[10px] font-black uppercase bg-white/5 text-gray-500 hover:bg-white/10 transition-all flex items-center gap-2"
          >
            + New Folder
          </button>
        )}
      </div>
    </div>
  );
}